var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovementBranchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512.162 512.162",
    height: 512,
    viewBox: "0 0 512.162 512.162",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m278.256 33.996-10.2 17.141-31.731 18.042-236.325 57.098v356.897c0 16.132 13.077 28.907 29.209 28.907h453.9l29.053-28.907v-392.08z",
    fill: "#fff5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.256 33.995s-21.28 16.855-21.28 16.855v461.231h225.187c16.568 0 29.999-13.431 29.999-29.999v-424.903s-233.906-23.184-233.906-23.184z",
    fill: "#e1f0f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339.552.081-107.207 69.098h279.817v-39.889c0-16.132-12.922-29.209-29.053-29.209h-143.557z",
    fill: "#00252d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 13.426v112.851h245.346c7.425 0 14.301-3.91 18.098-10.291l76.108-115.905h-326.207c-7.37 0-13.345 5.975-13.345 13.345z",
    fill: "#275a61"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.823,
    cy: 65.531,
    fill: "#f8036c",
    r: 15.943
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.103,
    cy: 65.531,
    fill: "#ffd800",
    r: 15.943
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181.343,
    cy: 65.531,
    fill: "#97e728",
    r: 15.943
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.976.081v122.692c4.44-2.996 5.417-4.21 11.38-14.267l71.197-108.425z",
    fill: "#004047"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m192.728 369.83v-179.537c0-7.254-5.881-13.135-13.135-13.135h-92.57c-7.254 0-13.135 5.881-13.135 13.135v179.537h-23.864c-6.758 0-10.053 8.249-5.155 12.905l79.053 75.155c5.065 4.816 13.015 4.821 18.087.013l79.278-75.16c4.908-4.653 1.615-12.912-5.148-12.912h-23.411z",
    fill: "#ff5964"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m322.524 268.834v179.537c0 7.254 5.881 13.135 13.135 13.135h92.57c7.254 0 13.135-5.881 13.135-13.135v-179.537h23.865c6.758 0 10.053-8.249 5.155-12.905l-79.053-75.155c-5.065-4.816-13.015-4.821-18.087-.013l-79.278 75.16c-4.908 4.653-1.615 12.912 5.148 12.912h23.41z",
    fill: "#00ca75"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovementBranchIcon);
export default __webpack_public_path__ + "static/media/movementBranchIcon.72adc502b2ae28d1148d7d1844b9b1ba.svg";
export { ForwardRef as ReactComponent };